<template>


<div id="documentation-side-menu" uk-offcanvas="mode: push; overlay: false; bg-close: false">

    <div class="uk-offcanvas-bar">
                <draggable
                    class="dragArea list-group"
                    :list="displayList"
                    :group="{ name: 'fields', pull: 'clone', put: () => true }"
                    :sortable="false"
                    @add="handleAdded"
            >
    <button class="uk-offcanvas-close" type="button" uk-close></button>

        <h1 class="docText">Documentation</h1>
      <h2 class="docText">{{questionObjectPretty}}</h2>
        <div v-html="questionObjectInfo"></div>
        <h2 class="docText">Related</h2>
        <div  v-for="r in questionObjectRelated"><a class="docText" href="#" @click="updateRelated(r)">{{ makePretty(r)}}</a></div>
                    </draggable>
    </div>

</div>

</template>

<script>

    import deslug from '@/utils/deslug'
  import UIkit from 'uikit'; // necessary for intro stuff
  import moment from 'moment'
  import apiCall from '../../store/apicall'
    import Draggable from "vuedraggable";


	export default {
		name: "DocumentationPanel",
    props: ["questionObject"],
    components: {Draggable,
    },
		data: function () {
			return {
              today: moment().format("MMMM-DD-YYYY"),
                questionObjectInfo: "<p>Please drag a data point over here to get information.</p>",
                questionObjectRelated: [],
                displayList: []
            }
        },
		methods: {
            updateRelated: function(r) {
                this.questionObject = r
            },
            makePretty: function(w) {
              return deslug(w).toUpperCase()
            },
            close: function() {
              UIkit.toggle('#documentation-side-menu').toggle()
            },
            handleAdded: function(added) {
                console.log("ADDED!")
                console.log(added.item.innerText);
                this.questionObject = added.item.innerText
            }
		},
        computed: {
		  questionObjectPretty: function() {
		      if (this.questionObject){
                return deslug(this.questionObject).toUpperCase()
              } else {
                return null
              }

          }
        },
        watch: {
            questionObject: function () {
                console.log("QUESTION OBJECT IS: ", this.questionObject);
                const _t = this;
                apiCall.post('/onboarding/', {
                    'purpose': 'get_document',
                    'parameters': {
                        'element': this.questionObject
                        }
                    }
                ).then(function (response) {
                    _t.questionObjectInfo = response.data.html_content
                    _t.questionObjectRelated = response.data.related_elements.map(x => x.element)
                }).catch(function (error) {
                    console.log(error)
                })
            }
        }
	}
</script>

<style lang="less" scoped>

  @import "../../assets/less/palette.less";
  @import "../../assets/less/theme.less";


  #custom-side-menu {
     height: 100vh;
      overflow: hidden;
  }

  .uk-offcanvas-bar {
      border-right: solid black 2px !important;
      background-color: @primary-4;
      color: white;
      height: 100vh;
  }


  .uk-iconnav-vertical {

    li {
      width: 100%;
      display: flex;
      font-size: 1.3em;


      a {
        margin-left: 1em;
        color: inherit;

        &:hover {
          text-decoration: none;
        }
      }

      &:hover {
        color: @secondary-4!important;
      }

    }

  }

  .menu-container {
     display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    height: 88vh;
    overflow-y: scroll;
    margin-top: 2em;


    .menu-section-title {
      font-size: 1.4em;
      margin-bottom: .8em;
      text-decoration: underline;
    }

    .menu-section {
       margin-bottom: 6vh;
    }

  }

  .info {
    color: @secondary-3;
  }

  .avatar {
     display: flex;
    width: 100%;
    align-items: center;
    font-size: 1.2em;

    .name {
      margin-left: 1em;
      max-width: 80%;
    }

  }

  .docText{
      color: white !important;
  }


@media (max-width: @breakpoint-medium) {
  .menu-container {
    justify-content: flex-start;
  }
}


</style>
